import { CommissionType } from '@/constants/reservations';

/**
 * Validates the commission amount based on the commission type.
 * @param {Object} node - The node object containing the value.
 * @param {CommissionType} commissionType - The commission type.
 * @returns {boolean} - True if the commission amount is valid, false otherwise.
 */
export const commissionRateAmount = (node, commissionType = CommissionType.PERCENTAGE) => {
  const value = parseFloat(node.value) || 0;
  if (commissionType === CommissionType.PERCENTAGE) {
    return value >= 1 && value <= 100;
  }
  return value >= 1;
};

commissionRateAmount.skipEmpty = false;

/**
 * Validates that the input value contains no whitespace characters.
 * @param {Object} node - The node object containing the value.
 * @returns {boolean} - True if the input contains no whitespace, false otherwise.
 */
export const noWhitespace = (node) => {
  return !/\s/.test(node.value);
};

/**
 * Validates that the input value contains at least one commissionable rate code.
 * @param {Object} node - The node object containing the value.
 * @returns {boolean} - True if the input contains at least one commissionable rate code, false otherwise.
 */
export const commissionable = (node, isCommissionable = true) => {
  if (isCommissionable === 'true') {
    return node.value?.some((item) => item.rate?.commissionable);
  }
  return !node.value?.some((item) => item.rate?.commissionable);
};

commissionable.skipEmpty = false;
